export default {
  sos: 'sos',
  ['365']: '365',
};
